import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '@components/template/Page';
import MembershipTable from './body/MembershipTable';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Admin = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Admin">
      <Container maxWidth="lg">
        <MembershipTable />
      </Container>
    </Page>
  );
};

export default Admin;
